import React from 'react';
import PropTypes from 'prop-types';
import { Button, Stack } from '@metarouter-private/mr-mui';

export default function ConfirmUpdateActions({ onClose, onSubmit, isSubmitting, progress }) {
  // Validation runs in the resolver on submit (handleSubmit only fires onFormSubmit
  // when valid), so the button stays enabled except while a submission is in flight.

  // A bulk update can span several sequential batches; show how many pipelines
  // have been processed so the button isn't an opaque spinner on large runs.
  const submitLabel = isSubmitting
    ? progress
      ? `Updating ${progress.completed}/${progress.total}...`
      : 'Updating...'
    : 'Update Pipelines';

  return (
    <Stack direction="row" spacing={2} justifyContent="flex-end">
      <Button variant="outlined" onClick={onClose} disabled={isSubmitting}>
        Cancel
      </Button>
      <Button variant="contained" onClick={onSubmit} disabled={isSubmitting} data-test-id="bulkStageSubmitButton">
        {submitLabel}
      </Button>
    </Stack>
  );
}

ConfirmUpdateActions.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  progress: PropTypes.shape({
    completed: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
  }),
};

ConfirmUpdateActions.defaultProps = {
  progress: null,
};
